var map = {
	"./Grundriss": 19137,
	"./Grundriss.tsx": 19137,
	"./Inspiration": 86347,
	"./Inspiration.tsx": 86347,
	"./Masseditor": 1089,
	"./Masseditor.tsx": 1089,
	"./Zauneditor": 3588,
	"./Zauneditor.tsx": 3588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10250;